// Copyright 2021 Sorama B.V.

import { autoinject } from "aurelia-framework";
import { SettingsModal } from "modules/modals/SettingsModal";
import { SpectrogramModule } from "modules/workflows/Analysis/Spectrogram/SpectrogramModule";

@autoinject
export class SpectrogramSettingsModal extends SettingsModal<SpectrogramModule> {}
